import AmericanExpressIcon from '@/assets/amex.svg?react';
import JCBIcon from '@/assets/jcb.svg?react';
import MasterCardIcon from '@/assets/mastercard.svg?react';
import StripeIcon from '@/assets/stripe.svg?react';
import VisaIcon from '@/assets/visa.svg?react';

import {
  PaymentPlatformIconStyles,
  PaymentPlatformsIconsStyles,
} from './PaymentPlatformsIcons.styles';

export const PaymentPlatformsIcons = () => {
  return (
    <PaymentPlatformsIconsStyles>
      <PaymentPlatformIconStyles>
        <VisaIcon />
      </PaymentPlatformIconStyles>

      <PaymentPlatformIconStyles>
        <JCBIcon />
      </PaymentPlatformIconStyles>

      <PaymentPlatformIconStyles>
        <MasterCardIcon />
      </PaymentPlatformIconStyles>

      <PaymentPlatformIconStyles>
        <StripeIcon />
      </PaymentPlatformIconStyles>

      <PaymentPlatformIconStyles>
        <AmericanExpressIcon />
      </PaymentPlatformIconStyles>
    </PaymentPlatformsIconsStyles>
  );
};
